import Header from '../Shared/Header';
import HeroSection from './HeroSection';
import About from './About';
import Experience from './Experience';
import Services from './Services';
import Facts from './Facts';
import Projects from './Projects';
import Education from './Education';
import Testimonial from './Testimonial';
import Contact from './Contact';
import Footer from '../Shared/Footer';

export default function Home() {
  return (
    <div className="bg-ink-950 min-h-screen">
      <div className="bg-canvas" aria-hidden="true">
        <div className="bg-blob bg-blob-1" />
        <div className="bg-blob bg-blob-2" />
        <div className="bg-blob bg-blob-3" />
      </div>

      <Header />

      <main>
        <HeroSection />

        <div className="divider mx-auto max-w-7xl" />

        <About />

        <div className="divider mx-auto max-w-7xl" />

        <Experience />

        <div className="divider mx-auto max-w-7xl" />

        <Services />

        <Facts />

        <div className="divider mx-auto max-w-7xl" />

        <Projects />

        <div className="divider mx-auto max-w-7xl" />

        <Education />

        <div className="divider mx-auto max-w-7xl" />

        <Testimonial />

        <div className="divider mx-auto max-w-7xl" />

        <Contact />
      </main>

      <Footer />
    </div>
  );
}
